<template>
  <div>
    <!-- <div class="fake__btn__group mb-3">
      <div
        id="Recruit"
        class="fake_btn"
        @click="changeTabRole('Recruit')"
      >
        <span>Tuyển dụng</span>
      </div>
      <div
        id="Payroll"
        class="fake_btn ml-2"
        @click="changeTabRole('Payroll')"
      >
        <span>Tính lương</span>
      </div>
      <div
        id="Administrative"
        class="fake_btn ml-2"
        @click="changeTabRole('Administrative')"
      >
        <span>Hành chính</span>
      </div>
    </div> -->
    <div class="content__group" id="content__group">
      <DashboardHrRecruit
        v-if="role == 'Recruit'"
      />
      <DashboardHrPayroll
        v-if="role == 'Payroll'"
        :listDepartment="listDepartments"
        :listEmployee="listEmployees"
      />
      <DashboardHrAdministrative
        v-if="role == 'Administrative'"
        :listDepartment="listDepartments"
        :listEmployee="listEmployees"
        :listContractType="listContractTypes"
      />
    </div>
  </div>
</template>
<script>
import DashboardHrRecruit from './DashboradHr/DashboardHrRecruit'
import DashboardHrPayroll from './DashboradHr/DashboardHrPayroll'
import DashboardHrAdministrative from './DashboradHr/DashboardHrAdministrative'
import DepartmentApi from '@/moduleApi/DepartmentApi'
import EmployeeApi from '@/moduleApi/EmployeeApi'
import EventBus from '@/service/EventBus'
import ContractTypeApi from '@/moduleApi/ContractTypeApi'
export default {
  components: {
    DashboardHrRecruit,
    DashboardHrPayroll,
    DashboardHrAdministrative,
  },
  data() {
    return {
      role: 'Administrative',
      listDepartments: [],
      listEmployees: [],
      listContractTypes: [],
    };
  },
  created() {
    this.hashUrl();
    this.removeAndSetClass(this.role);
    this.initData();
  },
  methods: {
    async initData() {
      const resApi = await DepartmentApi.list({
        filters: `disabled!=true`,
        fields: `id,name`,
        limit: 1000
      });
      const employeeApiRes = await EmployeeApi.list({
        filters: `status:in:DANG_LAM_VIEC,NGHI_SINH`,
        fields: `id,administrative_info,status,job_info,salary,start_work_date,employee_no`,
        limit: 999999
      });
      const contractTypeApiRes = await ContractTypeApi.list({
        filters: `disabled!=true`,
        fields: `id,name`,
        limit: 1000
      });
      this.listEmployees = employeeApiRes.result
      this.listDepartments = resApi.result
      this.listContractTypes = contractTypeApiRes.result
    },
    changeTabRole(role) {
      if (this.role == role) return;
      this.removeAndSetClass(role);
      this.changeRoutes();
      EventBus.$emit("ChangeRoute");
    },
    removeAndSetClass(role) {
      this.role = role;
      (document.querySelectorAll('.active') || []).forEach((item) => {
        item.classList.remove('active');
      });
      setTimeout(() => {
        let dom = document.getElementById(role)
        if (dom) dom .classList.add('active')
        this.scrollToTop();
      }, 50);
    },
    changeRoutes() {
      this.$router.replace({
        name: 'Admin-Hr-Dashboard',
        query: {
          role: this.role,
        },
      }).catch(() => {});
    },
    hashUrl() {
      if (this.$route.query.role) {
        this.removeAndSetClass(this.$route.query.role);
      }
    },
    scrollToTop(){
      document.getElementById("content__group").scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.fake__btn__group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  width: 400px;
  height: 50px;
  background-color: #fff;
  box-shadow: 0px 0px 20px rgb(43 43 43 / 13%);
  border-radius: 25px;
  .fake_btn {
    width: 100%;
    padding: 5px;
    text-align: center;
    background: #fdfdfd;
    box-shadow: 0px 0px 20px rgb(0 0 0 / 5%);
    border-radius: 25px;
    &:hover {
      cursor: pointer;
    }
    span {
      font-family: 'Roboto';
      font-size: 15px;
      letter-spacing: 0.01em;
    }
    &.active {
      background-color: var(--orange);
      color: #fff;
      font-size: 15px;
        span {
        font-weight: 500;
        font-size: 15px;
      }
    }
  }
}
.content__group {
  max-height: calc(100vh - 20px);
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
